import React, { memo, useEffect, useCallback, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import { getATopBanner } from '../../actions/arecommend';
import AButton from '../../components/AButton/AButton';
import { logging, logPostInfo } from '../../actions/log';
import styles from './ABanner.module.less';
import { CONTEXT } from '../../config';

const selectBanner = createSelector(
  state => state.arecommend,
  arecommend => arecommend.banner,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const bannerData = useSelector(selectBanner);
  const logInfoData = useSelector(selectLogInfo);

  const swiperEl = useRef(null);
  const [banners, setBanner] = useState(null);
  const [swiperParams, setSwiperParams] = useState(null);

  useEffect(() => {
    if (!bannerData || !bannerData.banners) {
      dispatch(getATopBanner({ code: 'soft' }));
    } else {
      const showBanner = [];
      bannerData.banners.forEach(banner => {
        if (
          (banner.targetType === '1' && banner.appInfo) ||
          (banner.targetType === '2' && banner.targetUrl) ||
          (banner.targetType === '3' && banner.ztId)
        ) {
          showBanner.push(banner);
        }
        // if (banner && banner.appInfo) {
        //   showBanner.push(banner)
        // }
      });
      setBanner(showBanner.slice(0, 10));
      getSwiperParams(showBanner.slice(0, 10));
    }
  }, [dispatch, bannerData]);

  useEffect(() => {
    const swiper = swiperEl.current && swiperEl.current.swiper;
    // 由于swiper组件没有封装 hover切换事件，所以这样处理鼠标hover切换轮播图。
    if (bannerData && bannerData.banners && bannerData.banners.length > 0 && swiper) {
      const paginations = document.querySelectorAll('.swiper-pagination-bullet');
      paginations.forEach((pagination, index) => {
        pagination.addEventListener(
          'mouseenter',
          () => {
            swiper.slideTo(1 + index + bannerData.banners.slice(0, 10).length);
          },
          false,
        );
      });
    }
  }, [bannerData, swiperEl, swiperEl.current]);

  const getSwiperParams = bannersArr => {
    const params = {
      speed: 800,
      loop: true,
      slidesPerView: 'auto',
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 50,
        depth: 300,
        modifier: 1,
        slideShadows: true,
      },
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: (index, className) => {
          return `<div class="${className}">
            <div class="swiper_pagination_round"></div>
          </div>`;
        },
      },
      on: {
        click(e) {
          const targetDom = e.path[0] || {};
          if (targetDom.className && targetDom.className.indexOf(styles.banner_img) > -1) {
            setTimeout(() => {
              const index = this.activeIndex % bannersArr.length;
              const bannerInfo = bannersArr[index] || {};
              handleBanner(bannerInfo);
            }, 30);
          }
        },
      },
    };
    setSwiperParams(params);
  };

  const goNext = () => {
    let nowTime = +new Date();
    let diffTime = nowTime - (window.swiperClickTime || 0);
    if (diffTime > 500) {
      diffTime = 500;
    }
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (swiper !== null) {
      swiper.slideNext(diffTime);
      window.swiperClickTime = nowTime;
    }
  };
  const goPrev = () => {
    let nowTime = +new Date();
    let diffTime = nowTime - (window.swiperClickTime || 0);
    if (diffTime > 500) {
      diffTime = 500;
    }
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (swiper !== null) {
      swiper.slidePrev(diffTime);
      window.swiperClickTime = nowTime;
    }
  };

  const handleBanner = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: 'A_Reco_Banner',
          label: '',
          param2: {
            source: 'A_Reco_Banner',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: bannerInfo.bizInfo,
        }),
      );

      if (bannerInfo.targetType === '1' || bannerInfo.targetType === '3') {
        dispatch(
          logPostInfo({
            source_p: 'A_Reco_Banner',
            source_pp: logInfoData.source_p,
          }),
        );
      }

      setTimeout(() => {
        if (bannerInfo.targetType === '1' && bannerInfo.appInfo && bannerInfo.appInfo.softID) {
          history.push(
            `${CONTEXT}/adetail/${bannerInfo.appInfo.packageName || ''}/${
              bannerInfo.appInfo.versionCode
            }/${bannerInfo.appInfo.bizInfo || '{}'}`,
          );
        } else if (bannerInfo.targetType === '2' && bannerInfo.targetUrl) {
          window.open(bannerInfo.targetUrl);
        } else if (bannerInfo.targetType === '3' && bannerInfo.ztId) {
          history.push(`${CONTEXT}/special?ztId=${bannerInfo.ztId}`);
        } else {
          history.push(`${CONTEXT}/error`);
        }
      }, 30);
    },
    [dispatch],
  );

  return (
    banners &&
    banners.length > 0 && (
      <div className={styles.banner}>
        <Swiper {...swiperParams} ref={swiperEl}>
          {banners.map((item, i) => (
            <div
              key={i}
              onMouseEnter={() => {
                if (swiperEl.current.swiper) swiperEl.current.swiper.autoplay.stop();
              }}
              onMouseLeave={() => {
                if (swiperEl.current.swiper) swiperEl.current.swiper.autoplay.start();
              }}
            >
              <div className={styles.banner_item} key={i}>
                <img className={styles.banner_img} src={item.contentImg} alt="" />
                {item.targetType === '1' && (
                  <div className={styles.banner_infos}>
                    <AButton
                      soft={item.appInfo}
                      info={{
                        className: styles.banner_soft_button,
                        className_busing: styles.banner_soft_button_busing,
                        className_open: styles.soft_button_open,
                        text: '安装',
                      }}
                      logInfo={{ source: 'A_Reco_Banner' }}
                    />
                  </div>
                )}
              </div>
              <div className="swiper-slide-shadow-left" />
              <div className="swiper-slide-shadow-right" />
            </div>
          ))}
        </Swiper>
        <div className={styles.banner_swiper_prev} onClick={goPrev} />
        <div className={styles.banner_swiper_next} onClick={goNext} />
      </div>
    )
  );
});
